export { default as IndexTableStickyCell } from './IndexTableStickyCell';
